import { createCart } from './create_cart'
import { IBuildCheckoutAttributes } from '../shopify_client/types'
import { shopifyGql } from '../shopify_client/graphql'

export async function ensureCartID(
  { cartID, buildCheckoutAttributes }:
    {
      cartID: string,
      buildCheckoutAttributes: IBuildCheckoutAttributes,
    },
): Promise<string> {
  if (await cartExists(cartID)) {
    return cartID
  }

  const cart = await createCart(buildCheckoutAttributes)

  return cart.id
}

async function cartExists(cartID: string): Promise<boolean> {
  if (cartID == undefined)
    return false

  const { data, errors } = await shopifyGql(
    `query cartQuery($cartID: ID!) { cart(id: $cartID) { id createdAt } }`,
    { cartID }
  )

  if (errors.length > 0) { throw new AggregateError(errors, 'ensureCartID.cartQuery') }

  return data.cart !== null
}
